import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35 0H0v35h35V0ZM8.869 26.111l1.581-3.642a8.628 8.628 0 1 1 3.26 2.78l-4.841.862Zm5.268-12.45a1.361 1.361 0 0 1 2.324.963v.959a1.361 1.361 0 0 1-.763 1.222 3.911 3.911 0 0 0 2.493 2.493 1.359 1.359 0 0 1 1.223-.763h.958a1.361 1.361 0 1 1 0 2.723h-.958a5.675 5.675 0 0 1-5.675-5.675v-.959c0-.36.143-.707.398-.962Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgWhatsapp;